import { createApp } from 'vue';
import 'vue@/ajaxDefaults.js';
import Global from 'vue@/plugin/global'
import ShotAndWaterBody from './components/shotAndWaterBody'


// eslint-disable-next-line no-new
createApp({
    components: {
        ShotAndWaterBody,
    },

    data() {
        const shotAndWater = window.results ? window.results.shot_and_water : {};
        const showShotAndWater = shotAndWater && !shotAndWater.isEmpty;
        const partSum =
            (shotAndWater?.Vattenarbete ?? 0) +
            (shotAndWater?.Skottfasthet ?? 0);
        const totalSum = partSum + (shotAndWater?.otherSum ?? 0);
        const { isAdmin } = window;

        const { registration } = window;
        const { id: registrationId, event: { id: eventId } } = registration;

        return {
            shotAndWater,
            showShotAndWater,
            otherSum: shotAndWater?.otherSum || 0,
            partSum,
            totalSum,
            registrationId,
            eventId,
            isAdmin,
        };
    },

    methods: {
        confirmRegistration() {
            if (confirm(this.$t('app.areYouSureThisCantBeUndoned'))) {
                this.$refs.confirmForm.submit();
            }
        },
        publishRegistration() {
            if (confirm(this.$t('app.areYouSureThisCantBeUndoned'))) {
                this.$refs.publishForm.submit();
            }
        },
        deleteRegistration() {
            if (confirm(this.$t('app.areYouSureThisCantBeUndoned'))) {
                this.$refs.deleteForm.submit();
            }
        },
        createShotAndWater() {
            this.showShotAndWater = true;
        },
        updateTotalSum(totalSum = this.totalSum, partSum = this.partSum) {
            this.totalSum = totalSum;
            this.partSum = partSum;
        },
    },
}).use(Global).mount('#skkRegistration');
